import { BaseError } from '@dynamic-labs-sdk/client';

export class InvalidPsbtError extends BaseError {
  constructor(message: string) {
    super({
      cause: null,
      code: 'invalid_psbt_error',
      docsUrl: null,
      name: 'InvalidPsbtError',
      shortMessage: message,
    });
  }
}
